/**
 * @enum {User_LOGIN_STATE}
 */
export const LOGIN_STATE = {
    LoggedOut: 0,
    SoftLoggedIn: 1,
    LoggedIn: 2,
};

/**
 * @enum {User_USER_TYPE}
 */
export const USER_TYPE = {
    Patient: 0,
    Provider: 1,
    ZdEmployee: 2,
    BookingAgent: 9,
};

/**
 * @enum {User_NOTIFICATION_TYPE}
 */
export const NOTIFICATION_TYPE = {
    ZocdocMessage: 'zocdocmessage',
    AppointmentConfirmed: 'appointmentconfirmed',
    AppointmentRescheduled: 'appointmentrescheduled',
    AppointmentCancelled: 'appointmentcancelled',
    AppointmentInfoNeeded: 'appointmentinfoneeded',
    AppointmentCheckIn: 'appointmentcheckin',
    AppointmentFeedback: 'appointmentfeedback',
    AppointmentAsyncBookingFailure: 'appointmentasyncbookingfailure',
};

/**
 * @enum {User_STATE_KEYS}
 */
export const STATE_KEYS = {
    User: 'user',
    LoginState: 'login_state',
    Notifications: 'notifications',
    UnseenNotificationCount: 'unseen_notification_count',
    UpcomingAppointments: 'upcoming_appointments',
    UserType: 'user_type',
};
